// cspell: ignore syncbird
import { StructFieldDefinition, StructFieldValue } from '../basic/index.js';
import { Syncbird } from "../syncbird.js";
export class NumberFieldType {
    TTypeScriptType;
    size;
    dataViewGetter;
    dataViewSetter;
    constructor(size, dataViewGetter, dataViewSetter) {
        this.size = size;
        this.dataViewGetter = dataViewGetter;
        this.dataViewSetter = dataViewSetter;
    }
    static Int8 = new NumberFieldType(1, 'getInt8', 'setInt8');
    static Uint8 = new NumberFieldType(1, 'getUint8', 'setUint8');
    static Int16 = new NumberFieldType(2, 'getInt16', 'setInt16');
    static Uint16 = new NumberFieldType(2, 'getUint16', 'setUint16');
    static Int32 = new NumberFieldType(4, 'getInt32', 'setInt32');
    static Uint32 = new NumberFieldType(4, 'getUint32', 'setUint32');
}
export class NumberFieldDefinition extends StructFieldDefinition {
    type;
    constructor(type, _typescriptType) {
        super();
        this.type = type;
    }
    getSize() {
        return this.type.size;
    }
    create(options, struct, value) {
        return new NumberFieldValue(this, options, struct, value);
    }
    deserialize(options, stream, struct) {
        return Syncbird
            .try(() => {
            return stream.read(this.getSize());
        })
            .then(array => {
            const view = new DataView(array.buffer, array.byteOffset, array.byteLength);
            const value = view[this.type.dataViewGetter](0, options.littleEndian);
            return this.create(options, struct, value);
        })
            .valueOrPromise();
    }
}
export class NumberFieldValue extends StructFieldValue {
    serialize(dataView, offset) {
        // `setBigInt64` requires a `bigint` while others require `number`
        // So `dataView[DataViewSetters]` requires `bigint & number`
        // and that is, `never`
        dataView[this.definition.type.dataViewSetter](offset, this.value, this.options.littleEndian);
    }
}
//# sourceMappingURL=number.js.map